import {
  active_batches_for_selectQuery,
  batchesForClassListReportQuery,
  batchesForLMSQuery,
  batchesForResultSheetQuery,
  batchForStudentBatchAssignmentQuery,
} from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';

export const getBatchesForSelect = (
  batches?:
    | batchForStudentBatchAssignmentQuery['active_batch']
    | active_batches_for_selectQuery['active_batch']
    | batchesForResultSheetQuery['batch']
    | batchesForLMSQuery['batch']
    | batchesForClassListReportQuery['batch'],
): HSMSSelectOption[] => {
  if (batches) {
    const batchesData: HSMSSelectOption[] = [];
    batches.forEach((batch) => {
      batchesData.push({
        value: batch.id,
        label: `${batch.name}: ${batch.year} ${batch.intake?.name}`,
      });
    });

    return batchesData.sort((firstValue, secondValue) =>
      firstValue.label.toString().localeCompare(secondValue.label.toString()),
    );
  }

  return [];
};
